import mixpanel from 'mixpanel-browser'
import { environment } from '../../../environments'
import type { MixPanelParams, MixPanelRegister } from './models'

export const createMixpanel = (externalUserkey?: string, mixPanelParams?: MixPanelParams) => {
  const { mixpanelToken } = environment()
  mixpanel.init(mixpanelToken)
  mixpanel.set_config({
    cross_subdomain_cookie: false,
    disable_persistence: true,
    ip: false,
  })
  mixpanel.identify(externalUserkey)
  const { Entitlements = [], ...rest } = mixPanelParams ?? {}
  const registerData: MixPanelRegister = {
    businessUnit: 'goto',
    application: 'goto-app',
    Entitlements,
    ...rest,
  }
  mixpanel.register(registerData)
  mixpanel?.people?.set({ Entitlements, ExternalUserkey: externalUserkey })
}
